import { Component, Input } from '@angular/core';

@Component({
  selector: 'lum-ui-textarea',
  templateUrl: './ui-textarea.component.html',
  styleUrls: ['./ui-textarea.component.scss'],
})
export class UiTextareaComponent {
  @Input()
  value :string | number = '';

  @Input()
  min :any = null;

  @Input()
  max :any = null;

  @Input()
  required :boolean = false;

  @Input()
  rows :number = 5;

  @Input()
  disabled :boolean = false;

  @Input()
  readonly :boolean = false;

  @Input()
  placeholder :string = 'Text here...';

  /**
   * Status handling
   */
  @Input()
  color :'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'negative' =
    'primary';

  /**
   * Manage Hints
   */
  @Input()
  hintMessage :any = null;

  @Input()
  hintColor :any = null;

  get classes() :string[] {
    const mode = `lum-textarea--${this.color}`;

    return ['lum-textarea', mode];
  }
}
